






























































import { Component, Vue, Emit } from 'vue-property-decorator';
import { pcService } from '../services/pc.service';
import Btn from '@/components/Btn.vue';
@Component({
  components: { Btn },
})
export default class Confirm extends Vue {
  isShow = false;
  data: any = {};
  hideConfirm() {
    pcService.confirm$.next({ isOpen: false, data: {} });
    this.data = {};
  }
  btnHandle(type: 'first' | 'second') {
    const fx = {
      first: this.data.firstFx,
      second: this.data.secondFx,
    };
    fx[type] && fx[type]();
    this.hideConfirm();
  }
  mounted() {
    pcService.confirm$.subscribe(res => {
      this.isShow = res.isOpen;
      this.data = res.data;
      if (!this.data.type) this.data.type = 'success';
    });
  }
}
